import axios from '@/api/axios';
import {
  UserDataResponse,
  User,
  SuccessResponse,
} from '@/types/api';
import apiConfig from '@/config/url-api';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  EditAccountCredentialRequest,
  EditAccountRequest,
  EditAccountSettingsForm,
} from '@/types/form';

/**
 * @param params
 * @returns
 *
 * Service update account user
 */
export const editAccount = async (params: EditAccountRequest): Promise<User | undefined> => {
  const response = await axios.post<UserDataResponse>(apiConfig.customer.edit, params);
  return response.data.data;
};

/**
 *
 * @returns
 * Hooks update account user
 */
export const useMutationEditAccount = () => {
  const userMutation = useMutation({
    mutationFn: (data: { params: EditAccountRequest }) => editAccount(data.params),
  } as UseMutationOptions<User, unknown, { params: EditAccountRequest }, unknown>);

  return userMutation;
};

/**
 * @param params
 * @returns
 *
 * Service update account user credential
 */
export const editAccountCredential = async (
  params: EditAccountCredentialRequest,
): Promise<boolean> => {
  await axios.post<SuccessResponse<boolean>>(apiConfig.customer.editCrendetial, params);
  return true;
};

/**
 *
 * @returns
 * Hooks update account user credential
 */
export const useMutationEditAccountCredential = () => {
  const userMutation = useMutation({
    mutationFn: (data: { params: EditAccountCredentialRequest }) =>
      editAccountCredential(data.params),
    onError: (error) => {
      return error;
    },
  } as UseMutationOptions<boolean, unknown, { params: EditAccountCredentialRequest }, unknown>);

  return userMutation;
};

/**
 * @param params
 * @returns
 *
 * Service update account user
 */
export const editSettings = async (params: EditAccountSettingsForm): Promise<User | undefined> => {
  const response = await axios.post<UserDataResponse>(apiConfig.customer.settings, params);
  return response.data.data;
};

/**
 *
 * @returns
 * Hooks update account user
 */
export const useMutationEditSettings = () => {
  const userMutation = useMutation({
    mutationFn: (data: { params: EditAccountSettingsForm }) => editSettings(data.params),
  } as UseMutationOptions<User, unknown, { params: EditAccountSettingsForm }, unknown>);

  return userMutation;
};
